import script from "./Compliance.vue?vue&type=script&lang=ts&setup=true"
export * from "./Compliance.vue?vue&type=script&lang=ts&setup=true"

import "./Compliance.vue?vue&type=style&index=0&id=6db1bc0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db1bc0c"]])

export default __exports__